import { render, staticRenderFns } from "./flats-crm-section.vue?vue&type=template&id=2f6a421a&"
import script from "./flats-crm-section.vue?vue&type=script&lang=js&"
export * from "./flats-crm-section.vue?vue&type=script&lang=js&"
import style0 from "./flats-crm-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports